import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation, fadeInUpOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {EventsService} from '../../../../services/events.service';
import {AnalyticsService} from '../../../../services/analytics.service';

@Component({
    selector: 'app-rating',
    templateUrl: './rating.component.html',
    styleUrls: ['./rating.component.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
        fadeInUpOnEnterAnimation({anchor: 'enterUp', duration: 300}),
    ],
})
export class RatingComponent implements OnInit {
    @Input() value: number;
    @Input() delay = 0;
    @Output() valueChange = new EventEmitter();

    variants: Array<number> = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

    constructor(
        private event: EventsService,
        private analytics: AnalyticsService,
    ) {
    }

    ngOnInit() {
    }

    onSelect(value) {
        this.event.publish('form:changed', 'coaching');
        this.value = value;
        this.valueChange.emit(this.value);
    }
}
